import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-shell" }
const _hoisted_2 = { class: "app-shell__main" }

import { ref, onMounted, watch } from 'vue';

import useContext from '@/composables/useContext';

import SiteHeader from '@/components/SiteHeader.vue';
import SiteFooter from '@/components/SiteFooter.vue';
import Search from '@/components/search/Search.vue';
import { setCookieInformationScript } from '../functions/cookie.functions';
import GiftCardRedirectNotice from "@/components/GiftCardRedirectNotice.vue";
import Snackbar from "@/components/Snackbar.vue";
import ScrollToTopButton from '@/components/ScrollToTopButton.vue';
import useWebsiteTexts from '@/composables/useWebsiteTexts';
import { useRouteScrollReset } from '@/composables/useRouteScrollReset';


export default /*@__PURE__*/_defineComponent({
  __name: 'StandardLayout',
  setup(__props) {

const isMounted = ref(false);
const showNotice = ref(false);
const showLoginSnackbar = ref(false);
const { channel } = useContext();
const { websiteText } = useWebsiteTexts();

useRouteScrollReset();

watch(channel, (newVal, _) => {
  if (newVal != undefined) {
    setCookieInformationScript(newVal.language);
  }
});

onMounted(async () => {
  isMounted.value = true;
  if (localStorage.getItem("ShowLoginNotification")) {
    showLoginSnackbar.value = true;
    localStorage.removeItem("ShowLoginNotification");
  }
  if (document.cookie.includes("GiftCardRedirected=1")) {
    showNotice.value = true;
    document.cookie = "GiftCardRedirected=; Max-Age=0; path=/;";
  }
});

const disableShowNotice = () => {
  showNotice.value = false;
  if (document.cookie.includes("GiftCardRedirected=1")) {
    document.cookie = "GiftCardRedirected=; Max-Age=0; path=/;";
  }
};


return (_ctx: any,_cache: any) => {
  const _component_router_page = _resolveComponent("router-page")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (showNotice.value)
      ? (_openBlock(), _createBlock(GiftCardRedirectNotice, {
          key: 0,
          disableShowNotice: disableShowNotice,
          message: _unref(websiteText)('giftcard__notice').value
        }, null, 8, ["message"]))
      : _createCommentVNode("", true),
    _createVNode(SiteHeader),
    (isMounted.value)
      ? (_openBlock(), _createBlock(Search, { key: 1 }))
      : _createCommentVNode("", true),
    _createElementVNode("main", _hoisted_2, [
      _createVNode(_component_router_page)
    ]),
    _createVNode(SiteFooter),
    (showLoginSnackbar.value)
      ? (_openBlock(), _createBlock(Snackbar, {
          key: 2,
          message: _unref(websiteText)('login__welcome_notice').value,
          onDismiss: _cache[0] || (_cache[0] = ($event: any) => (showLoginSnackbar.value = false))
        }, null, 8, ["message"]))
      : _createCommentVNode("", true),
    _createVNode(ScrollToTopButton)
  ]))
}
}

})